<template>
  <div>
    <TitlePage :title="$t('configurations')"></TitlePage>

    <v-layout wrap>

      <v-container fluid>
        <v-row>
          <v-col cols="2">
            <v-subheader>Google API key</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.google_api_key) ? '':$t('insertValue')" v-model="item.configurations.google_api_key" dense hide-details></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-subheader>Google Oauth Client Id</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.google_oauth_client_id) ? '':$t('insertValue')" v-model="item.configurations.google_oauth_client_id" dense hide-details></v-text-field>
          </v-col>

          <v-col cols="2">
            <v-subheader>Google Oauth Client Secret</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.google_oauth_client_secret) ? '':$t('insertValue')" v-model="item.configurations.google_oauth_client_secret" dense hide-details type="password"></v-text-field>
          </v-col>

          <v-col cols="2">
            <v-subheader>Google Oauth Redirect Url</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.google_oauth_redirect_url) ? '':$t('insertValue')" v-model="item.configurations.google_oauth_redirect_url" dense hide-details></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-divider class="marg-title"></v-divider>
          </v-col>

          <v-col cols="2">
            <v-subheader>AWS Access Key ID</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.aws_access_key) ? '':$t('insertValue')" v-model="item.configurations.aws_access_key" dense hide-details></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-subheader>AWS Access Secret Key</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.aws_secret_access_key) ? '':$t('insertValue')" v-model="item.configurations.aws_secret_access_key" dense hide-details type="password"></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-subheader>AWS Region</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.aws_region) ? '':$t('insertValue')" v-model="item.configurations.aws_region" dense hide-details></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-subheader>AWS Bucket</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.aws_bucket) ? '':$t('insertValue')" v-model="item.configurations.aws_bucket" dense hide-details></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-subheader>AWS Url</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.aws_url) ? '':$t('insertValue')" v-model="item.configurations.aws_url" dense hide-details></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-divider class="marg-title"></v-divider>
          </v-col>

          <!-- ── Email Provider ── -->
          <v-col cols="12">
            <v-subheader class="font-weight-bold">Email Provider</v-subheader>
          </v-col>
          <v-col cols="2"><v-subheader>Provider</v-subheader></v-col>
          <v-col cols="10">
            <v-select
              v-model="item.configurations.email_provider"
              :items="[{text:'Disabilitato', value:'disabled'},{text:'SMTP', value:'smtp'},{text:'Amazon SES', value:'ses'}]"
              dense hide-details
            ></v-select>
          </v-col>

          <template v-if="item.configurations.email_provider === 'smtp'">
          <v-col cols="2">
            <v-subheader>SMTP Host</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.smtp_host) ? '':$t('insertValue')" v-model="item.configurations.smtp_host" dense hide-details></v-text-field>
          </v-col>

          <v-col cols="2">
            <v-subheader>SMTP Port</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.smtp_port) ? '':$t('insertValue')" v-model="item.configurations.smtp_port" dense hide-details></v-text-field>
          </v-col>

          <v-col cols="2">
            <v-subheader>SMTP Username</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.smtp_username) ? '':$t('insertValue')" v-model="item.configurations.smtp_username" dense hide-details></v-text-field>
          </v-col>

          <v-col cols="2">
            <v-subheader>SMTP Password</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.smtp_password) ? '':$t('insertValue')" v-model="item.configurations.smtp_password" dense hide-details type="password"></v-text-field>
          </v-col>

          <v-col cols="2">
            <v-subheader>SMTP Security</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-select
              v-model="item.configurations.smtp_security"
              :items="[{text:'SSL (porta 465)', value:'ssl'},{text:'STARTTLS (porta 587)', value:'tls'}]"
              dense hide-details
            ></v-select>
          </v-col>
          </template>

          <v-col cols="12">
            <v-divider class="marg-title"></v-divider>
          </v-col>


          <v-col cols="2">
            <v-subheader>PayPal Client Id</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.paypal_client_id) ? '':$t('insertValue')" v-model="item.configurations.paypal_client_id" dense hide-details></v-text-field>
          </v-col>

          <v-col cols="2">
            <v-subheader>PayPal Client Secret</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.paypal_client_secret) ? '':$t('insertValue')" v-model="item.configurations.paypal_client_secret" dense hide-details type="password"></v-text-field>
          </v-col>

          <v-col cols="2">
            <v-subheader>PayPal Sandbox</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-switch v-model="item.configurations.paypal_sandbox" inset :label="$t('status')" dense></v-switch>
          </v-col>

          <v-col cols="12">
            <v-divider class="marg-title"></v-divider>
          </v-col>


          <v-col cols="2">
            <v-subheader>Stripe Public Key</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.stripe_public_key) ? '':$t('insertValue')" v-model="item.configurations.stripe_public_key" dense hide-details></v-text-field>
          </v-col>

          <v-col cols="2">
            <v-subheader>Stripe Secret Key</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.stripe_secret_key) ? '':$t('insertValue')" v-model="item.configurations.stripe_secret_key" dense hide-details type="password"></v-text-field>
          </v-col>

          <v-col cols="2">
            <v-subheader>Stripe Sandbox</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-switch v-model="item.configurations.stripe_sandbox" inset :label="$t('status')" dense></v-switch>
          </v-col>

          <v-col cols="12">
            <v-divider class="marg-title"></v-divider>
          </v-col>

          <v-col cols="2">
            <v-subheader>Facebook App Id</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.facebook_app_id) ? '':$t('insertValue')" v-model="item.configurations.facebook_app_id" dense hide-details></v-text-field>
          </v-col>

          <v-col cols="2">
            <v-subheader>Facebook App Secret</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.facebook_app_secret) ? '':$t('insertValue')" v-model="item.configurations.facebook_app_secret" dense hide-details type="password"></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-divider class="marg-title"></v-divider>
          </v-col>

          <v-col cols="2">
            <v-subheader>Play Store App link</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.play_store_app) ? '':$t('insertValue')" v-model="item.configurations.play_store_app" dense hide-details></v-text-field>
          </v-col>

          <v-col cols="2">
            <v-subheader>Apple Store App Link</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.apple_store_app) ? '':$t('insertValue')" v-model="item.configurations.apple_store_app" dense hide-details></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-divider class="marg-title"></v-divider>
          </v-col>

          <v-col cols="2">
            <v-subheader>Twilio Account Sid</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.twilio_accountSid) ? '':$t('insertValue')" v-model="item.configurations.twilio_accountSid" dense hide-details></v-text-field>
          </v-col>

          <v-col cols="2">
            <v-subheader>Twilio Auth Token</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.twilio_authToken) ? '':$t('insertValue')" v-model="item.configurations.twilio_authToken" dense hide-details type="password"></v-text-field>
          </v-col>

          <v-col cols="2">
            <v-subheader>Twilio Number</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.twilio_number) ? '':$t('insertValue')" v-model="item.configurations.twilio_number" dense hide-details></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-divider class="marg-title"></v-divider>
          </v-col>

          <v-col cols="2">
            <v-subheader>Limite classifica (Top N)</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field
              label="Default: 100"
              v-model="item.configurations.leaderboard_limit"
              dense
              hide-details
              type="number"
              min="10"
              max="1000"
            ></v-text-field>
          </v-col>

          <v-col cols="12"><v-divider class="marg-title"></v-divider></v-col>

          <!-- ── Login Providers ── -->
          <v-col cols="12">
            <v-subheader class="font-weight-bold">Login Providers</v-subheader>
          </v-col>
          <v-col cols="2"><v-subheader>Google</v-subheader></v-col>
          <v-col cols="10">
            <v-switch v-model="item.configurations.login_providers.google" inset label="Abilitato" dense hide-details></v-switch>
          </v-col>
          <v-col cols="2"><v-subheader>Facebook</v-subheader></v-col>
          <v-col cols="10">
            <v-switch v-model="item.configurations.login_providers.facebook" inset label="Abilitato" dense hide-details></v-switch>
          </v-col>
          <v-col cols="2"><v-subheader>Apple</v-subheader></v-col>
          <v-col cols="10">
            <v-switch v-model="item.configurations.login_providers.apple" inset label="Abilitato" dense hide-details></v-switch>
          </v-col>
          <v-col cols="2"><v-subheader>Amazon</v-subheader></v-col>
          <v-col cols="10">
            <v-switch v-model="item.configurations.login_providers.amazon" inset label="Abilitato" dense hide-details></v-switch>
          </v-col>

          <v-col cols="12"><v-divider class="marg-title"></v-divider></v-col>

          <!-- ── Amazon SES ── -->
          <template v-if="item.configurations.email_provider === 'ses'">
          <v-col cols="12">
            <v-subheader class="font-weight-bold">Amazon SES (Email)</v-subheader>
          </v-col>
          <v-col cols="2"><v-subheader>SES Access Key ID</v-subheader></v-col>
          <v-col cols="10">
            <v-text-field :label="item.configurations.ses.access_key_id ? '' : $t('insertValue')" v-model="item.configurations.ses.access_key_id" dense hide-details></v-text-field>
          </v-col>
          <v-col cols="2"><v-subheader>SES Secret Access Key</v-subheader></v-col>
          <v-col cols="10">
            <v-text-field :label="item.configurations.ses.secret_access_key ? '' : $t('insertValue')" v-model="item.configurations.ses.secret_access_key" dense hide-details type="password"></v-text-field>
          </v-col>
          <v-col cols="2"><v-subheader>SES Region</v-subheader></v-col>
          <v-col cols="10">
            <v-text-field label="es. eu-west-1" v-model="item.configurations.ses.region" dense hide-details></v-text-field>
          </v-col>
          <v-col cols="2"><v-subheader>SES From Email</v-subheader></v-col>
          <v-col cols="10">
            <v-text-field label="es. noreply@ucamp.it" v-model="item.configurations.ses.from_email" dense hide-details></v-text-field>
          </v-col>

          <v-col cols="12"><v-divider class="marg-title"></v-divider></v-col>
          </template>

          <!-- ── Apple OAuth ── -->
          <v-col cols="12">
            <v-subheader class="font-weight-bold">Apple Sign In</v-subheader>
          </v-col>
          <v-col cols="2"><v-subheader>Service ID (client_id)</v-subheader></v-col>
          <v-col cols="10">
            <v-text-field label="es. it.ucamp.app.web" v-model="item.configurations.apple_oauth.client_id" dense hide-details></v-text-field>
          </v-col>
          <v-col cols="2"><v-subheader>Team ID</v-subheader></v-col>
          <v-col cols="10">
            <v-text-field :label="item.configurations.apple_oauth.team_id ? '' : $t('insertValue')" v-model="item.configurations.apple_oauth.team_id" dense hide-details></v-text-field>
          </v-col>
          <v-col cols="2"><v-subheader>Key ID</v-subheader></v-col>
          <v-col cols="10">
            <v-text-field :label="item.configurations.apple_oauth.key_id ? '' : $t('insertValue')" v-model="item.configurations.apple_oauth.key_id" dense hide-details></v-text-field>
          </v-col>
          <v-col cols="2"><v-subheader>Private Key (.p8)</v-subheader></v-col>
          <v-col cols="10">
            <v-textarea :label="item.configurations.apple_oauth.private_key ? '' : 'Incolla il contenuto del file .p8'" v-model="item.configurations.apple_oauth.private_key" dense hide-details rows="4" outlined></v-textarea>
          </v-col>

          <v-col cols="12"><v-divider class="marg-title"></v-divider></v-col>

          <!-- ── Amazon Login ── -->
          <v-col cols="12">
            <v-subheader class="font-weight-bold">Login with Amazon</v-subheader>
          </v-col>
          <v-col cols="2"><v-subheader>Client ID</v-subheader></v-col>
          <v-col cols="10">
            <v-text-field :label="item.configurations.amazon_oauth.client_id ? '' : $t('insertValue')" v-model="item.configurations.amazon_oauth.client_id" dense hide-details></v-text-field>
          </v-col>
          <v-col cols="2"><v-subheader>Client Secret</v-subheader></v-col>
          <v-col cols="10">
            <v-text-field :label="item.configurations.amazon_oauth.client_secret ? '' : $t('insertValue')" v-model="item.configurations.amazon_oauth.client_secret" dense hide-details type="password"></v-text-field>
          </v-col>

          <v-col cols="12"><v-divider class="marg-title"></v-divider></v-col>

          <!-- ── Email Verification ── -->
          <v-col cols="2"><v-subheader>JWT Email Verification Secret</v-subheader></v-col>
          <v-col cols="10">
            <v-text-field :label="item.configurations.jwt_email_verification_secret ? '' : $t('insertValue')" v-model="item.configurations.jwt_email_verification_secret" dense hide-details type="password"></v-text-field>
          </v-col>

          <v-col cols="12"><v-divider class="marg-title"></v-divider></v-col>

          <!-- ── App Version (aggiornamento forzato) ── -->
          <v-col cols="12">
            <v-subheader class="font-weight-bold">Versioni App — Aggiornamento Forzato</v-subheader>
          </v-col>
          <v-col cols="2"><v-subheader>Aggiornamento forzato</v-subheader></v-col>
          <v-col cols="10">
            <v-switch
              v-model="item.configurations.app_version.force_update_enabled"
              :label="item.configurations.app_version.force_update_enabled ? 'Aggiornamento forzato ATTIVO' : 'Aggiornamento forzato DISATTIVATO'"
              :color="item.configurations.app_version.force_update_enabled ? 'error' : 'success'"
              inset dense hide-details
            ></v-switch>
            <v-alert v-if="!item.configurations.app_version.force_update_enabled" type="success" dense text class="mt-2">
              Il forcing è disabilitato: nessun utente vede la modale di aggiornamento.
            </v-alert>
          </v-col>
          <v-col cols="2"><v-subheader>Versione minima iOS</v-subheader></v-col>
          <v-col cols="10">
            <v-text-field label="es. 1.0.0" v-model="item.configurations.app_version.min_ios" dense hide-details></v-text-field>
          </v-col>
          <v-col cols="2"><v-subheader>Versione minima Android</v-subheader></v-col>
          <v-col cols="10">
            <v-text-field label="es. 1.0.0" v-model="item.configurations.app_version.min_android" dense hide-details></v-text-field>
          </v-col>
          <v-col cols="2"><v-subheader>Versione minima Web</v-subheader></v-col>
          <v-col cols="10">
            <v-text-field label="es. 1.0.0" v-model="item.configurations.app_version.min_web" dense hide-details></v-text-field>
          </v-col>
          <v-col cols="2"><v-subheader>URL App Store iOS</v-subheader></v-col>
          <v-col cols="10">
            <v-text-field :label="item.configurations.app_version.store_ios ? '' : $t('insertValue')" v-model="item.configurations.app_version.store_ios" dense hide-details></v-text-field>
          </v-col>
          <v-col cols="2"><v-subheader>URL Play Store Android</v-subheader></v-col>
          <v-col cols="10">
            <v-text-field :label="item.configurations.app_version.store_android ? '' : $t('insertValue')" v-model="item.configurations.app_version.store_android" dense hide-details></v-text-field>
          </v-col>
          <v-col cols="2"><v-subheader>Messaggio aggiornamento</v-subheader></v-col>
          <v-col cols="10">
            <v-textarea :label="item.configurations.app_version.note ? '' : 'Messaggio opzionale per l\'utente'" v-model="item.configurations.app_version.note" dense hide-details rows="2" outlined></v-textarea>
          </v-col>

        </v-row>

      </v-container>

      <v-flex md12 class="d-flex">
        <v-divider class="marg-title"></v-divider>
      </v-flex>
      <v-flex md12 class="pt-5 d-flex buttons-group-mobile">
        <v-btn elevation="2" color="" class="mr-auto" @click="$router.go(-1)">
          <v-icon left>mdi-keyboard-backspace</v-icon>
          {{ $t('back') }}
        </v-btn>
        <v-btn elevation="2" color="primary" class="ml-auto" @click="save" type="submit">
          {{ $t('save') }}
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-flex>

    </v-layout>
  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  name: "Configurations",
  components: {TitlePage},
  data() {
    return {
      item: {
        name: 'webapp',
        configurations: {
          google_api_key: '',
          aws_access_key: '',
          aws_secret_access_key: '',
          aws_region: '',
          aws_bucket: '',
          aws_url: '',
          smtp_host: '',
          smtp_port: '',
          smtp_username: '',
          smtp_password: '',
          smtp_security: '',
          paypal_client_id: '',
          paypal_client_secret: '',
          paypal_sandbox: false,
          google_oauth_client_id: '',
          google_oauth_client_secret: '',
          google_oauth_redirect_url: '',
          facebook_app_id: '',
          facebook_app_secret: '',
          play_store_app: '',
          apple_store_app: '',
          twilio_accountSid: '',
          twilio_authToken: '',
          twilio_number: '',
          stripe_public_key: '',
          stripe_secret_key: '',
          stripe_sandbox: false,
          leaderboard_limit: 100,
          email_provider: 'disabled',
          login_providers: { google: true, facebook: false, apple: false, amazon: false },
          ses: { access_key_id: '', secret_access_key: '', region: 'eu-west-1', from_email: '' },
          apple_oauth: { client_id: '', team_id: '', key_id: '', private_key: '' },
          amazon_oauth: { client_id: '', client_secret: '' },
          jwt_email_verification_secret: '',
          app_version: { min_ios: '1.0.0', min_android: '1.0.0', min_web: '1.0.0', store_ios: '', store_android: '', note: '', force_update_enabled: true },
        }
      }
    };
  },
  async created(){
    this.setLoading(true);
    const config = await this.editItem({ name: this.item.name });
    const loaded = config.result.configurations || {};
    // Deep merge: flat keys override defaults; nested objects merged explicitly
    this.item.configurations = {
      ...this.item.configurations,
      ...loaded,
      login_providers: { ...this.item.configurations.login_providers, ...(loaded.login_providers || {}) },
      ses: { ...this.item.configurations.ses, ...(loaded.ses || {}) },
      apple_oauth: { ...this.item.configurations.apple_oauth, ...(loaded.apple_oauth || {}) },
      amazon_oauth: { ...this.item.configurations.amazon_oauth, ...(loaded.amazon_oauth || {}) },
      app_version: { ...this.item.configurations.app_version, ...(loaded.app_version || {}) },
    };
    this.setLoading(false);
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'editItem': 'configurations/edit',
      'updateItem': 'configurations/update'
    }),
    async save(){

      await this.setLoading(true);
      var result = await this.updateItem(this.item)
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }

    },

  },
  mounted() {

  },
}
</script>

<style scoped>

</style>